import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetSurchargeDateBlockSchema(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery({
    queryKey: [
      ...roomRateAvailabilityQueryKeys.all,
      'surchargeSchema',
      propertyId ?? '',
      roomTypeId ?? '',
      roomRateId ?? '',
    ],
    queryFn: async () =>
      (await ReservationService.getSurchargeDateBlockSchema(propertyId, roomTypeId, roomRateId)).post.body.schema,
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
